"use strict";Object.defineProperty(exports, "__esModule", {value: true});
var _browserTransport = require('shared/services/directUpload/browserTransport');

// Chat attachments upload in chunks straight to GCS from the browser.
 const browserMessageUploadTransport = async file =>
  file instanceof Blob && file.size > 0
    ? { transport: _browserTransport.createBrowserTransport.call(void 0, file), size: file.size }
    : null; exports.browserMessageUploadTransport = browserMessageUploadTransport
